export default "__VITE_ASSET__BNmD_edn__"